export enum ItEventType {
    FeatureUsageEvent,
    BusinessProcessEvent,
    BusinessEventMessageExchange,
    BusinessEventEntityUpdate,
    BusinessEventDatabaseRecord,
    SystemEvent,
    Other
}